export default function MarksTableHead() {
  return (
    <thead>
      <tr>
        <th className="table-th">Assignment</th>
        <th className="table-th">Date</th>
        <th className="table-th">Student Name</th>
        <th className="table-th">Repo Link</th>
        <th className="table-th">Mark</th>
      </tr>
    </thead>
  );
}
